<template>
  <div class="auth-page" :class="{ 'auth-modal-page': modalMode }">
    <!-- 弹窗模式：只渲染弹窗遮罩 + 卡片 -->
    <template v-if="modalMode">
      <div class="auth-modal-mask" @click.self="$emit('close')">
        <div class="auth-modal-content">
          <div class="auth-modal-close" @click="$emit('close')">×</div>
          <div class="auth-card">
            <slot></slot>
          </div>
        </div>
      </div>
    </template>

    <!-- 页面模式：完整布局 -->
    <template v-else>
      <div class="auth-bg">
        <!-- Logo -->
        <img class="logo-header" :src="require('./login-img/logo-header.png')" />

        <!-- 返回首页 -->
        <div class="back-home" @click="$router.push('/')">
          <img class="back-icon" :src="require('./login-img/FigmaDDSSlicePNGcabdd2f009de209dbd020527e67df803.png')" />
          <span class="back-text">返回首页</span>
        </div>

        <!-- 顶部提示插槽 -->
        <slot name="hint"></slot>

        <!-- 卡片容器 -->
        <div class="auth-card">
          <slot></slot>
        </div>

        <!-- 版权 -->
        <div class="copyright">
          《中国品牌》杂志社、中国品牌网&nbsp;&nbsp;&nbsp;&nbsp;法律顾问：北京市信之源律师事务所<br />
          Copyright © 2008-2028 cbrand.com.cn All rights reserved 中国品牌网版权所有<br />
          京ICP备 16035947 号
        </div>
      </div>
    </template>

    <!-- 消息弹层 -->
    <div class="toast-mask" v-if="toast.show" @click.self="hideToast">
      <div class="toast-content" :class="toast.type">
        <span class="toast-text">{{ toast.message }}</span>
        <span class="toast-close" @click="hideToast">×</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuthLayout',
  props: {
    modalMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      toast: {
        show: false,
        message: '',
        type: 'info',
        timer: null
      }
    }
  },
  methods: {
    showToast(message, type = 'info') {
      if (this.toast.timer) clearTimeout(this.toast.timer)
      this.toast.show = true
      this.toast.message = message
      this.toast.type = type
      this.toast.timer = setTimeout(() => {
        this.hideToast()
      }, 3000)
    },
    hideToast() {
      this.toast.show = false
      if (this.toast.timer) clearTimeout(this.toast.timer)
    }
  },
  beforeDestroy() {
    if (this.toast.timer) clearTimeout(this.toast.timer)
  }
}
</script>

<style scoped>
* { box-sizing: border-box; margin: 0; padding: 0; }

.auth-page {
  width: 1400px;
  min-height: 1161px;
  margin: 0 auto;
  background: #fff;
}

.auth-bg {
  width: 1400px;
  min-height: 1161px;
  background: url('./login-img/FigmaDDSSlicePNGa9da2e2723302094c7132a362227dc1f.png') center top / cover no-repeat;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Logo */
.logo-header {
  width: 577px;
  margin-top: 40px;
  object-fit: contain;
}

/* 返回首页 */
.back-home {
  display: flex;
  align-items: center;
  width: 577px;
  margin-top: 50px;
  cursor: pointer;
}
.back-icon { width: 22px; height: 20px; margin-right: 10px; }
.back-text {
  color: rgba(136, 136, 136, 1);
  font-size: 22px;
  font-family: Microsoft YaHei, sans-serif;
}

/* 卡片容器 */
.auth-card {
  width: 577px;
  background: rgba(255, 255, 255, 1);
  border-radius: 0 0 16px 16px;
  margin-top: 15px;
  overflow: visible;
}

/* 版权 */
.copyright {
  width: 577px;
  text-align: center;
  font-size: 14px;
  color: rgba(102, 102, 102, 1);
  font-family: Microsoft YaHei, sans-serif;
  line-height: 24px;
  margin-top: 60px;
}

/* 弹窗模式 */
.auth-modal-page {
  width: auto;
  min-height: auto;
  margin: 0;
  background: transparent;
}

.auth-modal-mask {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9998;
}

.auth-modal-content {
  position: relative;
  width: 577px;
  background: transparent;
}

.auth-modal-close {
  position: absolute;
  top: -40px;
  right: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 28px;
  cursor: pointer;
  z-index: 1;
}

/* 消息弹层 */
.toast-mask {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.toast-content {
  min-width: 240px;
  max-width: 420px;
  padding: 14px 24px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
.toast-content.success { border-left: 4px solid rgba(82, 196, 26, 1); }
.toast-content.error { border-left: 4px solid rgba(228, 2, 16, 1); }
.toast-content.warning { border-left: 4px solid rgba(250, 173, 20, 1); }
.toast-content.info { border-left: 4px solid rgba(24, 144, 255, 1); }
.toast-text {
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  font-family: Microsoft YaHei, sans-serif;
  line-height: 1.5;
}
.toast-close {
  font-size: 18px;
  color: rgba(153, 153, 153, 1);
  cursor: pointer;
  line-height: 1;
}
.toast-close:hover { color: rgba(51, 51, 51, 1); }
</style>
